import { filterOptions } from '@/utils/query-base'
import { formatSapDate } from '@/mixins/index'
// const be = filterOptions(['EQ'])
const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export default {
  'partner': {
    title: '客户编号',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '客户编号'
    }
  },
  'name_org1': {
    title: '客户名称',
    type: 'input',
    equation: cusname,
    width: 250
  },
  'zzfld000016': {
    describe: true,
    title: '客户类型',
    type: 'select',
    equation: city,
    dictionary: 'A0009'
  },
  'product_id': {
    title: '产品ID',
    type: 'input',
    equation: all,
    width: 200
  },
  'short_text': {
    title: '产品描述',
    type: 'input',
    equation: all,
    width: 200
  },
  'chfl': {
    describe: true,
    title: '存货分类',
    type: 'select',
    equation: city,
    dictionary: 'A0019',
    width: 'auto'
  },
  'datum': {
    title: '创建日期',
    type: 'date',
    equation: all,
    formatter: ({ cellValue }) => formatSapDate(cellValue)
  }
}



// WEBPACK FOOTER //
// ./src/views/client-manage/config/customerSaleableProduct.js